module.exports = __webpack_public_path__ + "static/media/pic10.53c67b88.jpg";